export default __webpack_public_path__ + "static/media/self.a3e614a2.jpg";